export const URL_BUY_MASS_VIP = 'https://www.kuaizhan.com/v3/wallet/premium/wx-mass';
export const packageIntroList = [
  {
    type: 'FREE',
    title: '免费版',
    tip: '建议群发需求小的用户使用',
    logo: 'https://pic.kuaizhan.com/g3/f9/7b/b016-9821-4d0d-a676-040697603aa318',
    descriptions: ['无裂变海报', '不支持智能回复', '渠道二维码5条', '关键词自动回复次数200/天', '客服群发配额300条/天'],
  },
  {
    type: 'ADVANCED',
    title: '高级版',
    price: {
      year: 880,
    },
    logo: 'https://pic.kuaizhan.com/g3/ef/79/4b9b-10c7-4722-af22-7577f606362885',
    descriptions: ['有裂变海报', '支持智能回复', '渠道二维码50条', '关键词自动回复次数1000/天', '客服群发配额5w条/天'],
    btn: {
      text: '立即购买',
      link: URL_BUY_MASS_VIP,
    },
  },
  {
    type: 'COMPANY',
    title: '企业版',
    price: {
      year: 1899,
    },
    logo: 'https://pic.kuaizhan.com/g3/c1/48/8acd-edd5-4ede-845a-e5bf5b4dc82771/imageView/v1/thumbnail/105x115',
    descriptions: ['有裂变海报', '支持智能回复', '渠道二维码500条', '关键词自动回复次数3000/天', '客服群发配额10w条/天'],
    btn: {
      text: '立即购买',
      link: URL_BUY_MASS_VIP,
    },
  },
  {
    type: 'EXCLUSIVE',
    title: ' 旗舰版',
    price: {
      year: 3999,
    },
    logo: 'https://pic.kuaizhan.com/g3/04/d3/4407-8cad-4b08-9a25-8747d1369dd530/imageView/v1/thumbnail/105x115',
    descriptions: ['有裂变海报', '支持智能回复', '渠道二维码不限制', '关键词自动回复次数不限制', '客服群发配额20w条/天'],
    btn: {
      text: '立即购买',
      link: URL_BUY_MASS_VIP,
    },
  },
];

export const massPriceThemeColors = {
  FREE: '#7A83AB',
  ADVANCED: '#DD9A83',
  COMPANY: '#FDAA03',
  EXCLUSIVE: '#363636',
};

export const headerData = [
  {
    title: '免费版',
    themeColor: massPriceThemeColors.FREE,
    // link: URL_WORKSPACE,
    // btnText: '立即体验',
  },
  {
    title: '高级版',
    themeColor: massPriceThemeColors.ADVANCED,
    // link: URL_WALLET,
    // btnText: '立即购买',
  },
  {
    title: '企业版',
    themeColor: massPriceThemeColors.COMPANY,
    // link: URL_WALLET,
    // btnText: '立即购买',
  },
  {
    title: '旗舰版',
    themeColor: massPriceThemeColors.EXCLUSIVE,
    // link: URL_WALLET,
    // btnText: '立即购买',
  },
];

export const addtionalServicesList: Array<{
  title: string;
  desc?: string[];
  price?: string | number;
  unit?: string[];
  btnText: string;
  link?: string;
  contactUs?: boolean;
}> = [
  {
    title: '接入公众号个数',
    desc: ['接入公众号个数100元/个/年', '最终解释权归快站所有'],
    price: '100',
    unit: ['个', '/年'],
    btnText: '立即购买',
    link: URL_BUY_MASS_VIP,
  },
  // {
  //     title: '客服群发加量包',
  //     desc: '需购买群发免费版以上的套餐后可提升客服群发额度，加量包消耗后不会刷新',
  //     price: '100',
  //     unit: ['10w', '条'],
  //     btnText: '立即购买',
  //     link: URL_BUY_MASS_VIP,
  // },
  // {
  //     title: '模板群发加量包',
  //     desc: '需购买群发免费版以上的套餐后可提升模板群发额度，加量包消耗后不会刷新',
  //     price: '100',
  //     unit: ['10w', '条'],
  //     btnText: '立即购买',
  //     link: URL_BUY_MASS_VIP,
  // },
  // {
  //     title: '红包功能',
  //     desc: '任务/积分红包，高效拉新促活',
  //     price: '1500',
  //     unit: ['账号', '年'],
  //     btnText: '立即购买',
  //     link: URL_BUY_MASS_VIP,
  // },
  // {
  //   title: '定制 VIP',
  //   desc: [`更加稳定，极速`],
  //   btnText: '联系我们',
  //   contactUs: true,
  // },
];

export const ThemeColorEnums = {
  1: '#4D8DF7',
  2: '#FF9A00',
  3: '#FF4F25',
};

export const subTableData = [
  {
    title: '基础功能',
    desc: '',
    id: 'table-marketing-plugin',
    data: [
      [
        {
          text: '数据统计',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '粉丝画像',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '黑名单',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '自定义菜单',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '个性化菜单',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '图文消息',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '消息类型',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
      ],
    ],
  },
  {
    title: '高级营销功能',
    desc: '',
    id: 'table-shop',
    data: [
      [
        {
          text: '渠道二维码',
          hint: '',
        },
        {
          text: '5条',
          hint: '',
        },
        {
          text: '50条',
          hint: '',
        },
        {
          text: '500条',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
      ],
      [
        {
          text: '裂变海报',
          hint: '',
        },
        {
          text: '0',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '自动打标签',
          hint: '',
        },
        {
          text: '5条/天',
          hint: '',
        },
        {
          text: '20条/天',
          hint: '',
        },
        {
          text: '50条/天',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
      ],
    ],
  },
  {
    title: '自动回复',
    desc: '',
    id: 'table-page',
    data: [
      [
        {
          text: '关键词自动回复',
          hint: '',
        },
        {
          text: '5个',
          hint: '',
        },
        {
          text: '60个',
          hint: '',
        },
        {
          text: '120个',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
      ],
      [
        {
          text: '关键词自动回复次数',
          hint: '',
        },
        {
          text: '200/天',
          hint: '',
        },
        {
          text: '1000/天',
          hint: '',
        },
        {
          text: '3000/天',
          hint: '',
        },
        {
          text: '不限',
          hint: '',
        },
      ],
      [
        {
          text: '单次自动回复条数',
          hint: '',
        },
        {
          text: '1条',
          hint: '',
        },
        {
          text: '50条',
          hint: '',
        },
        {
          text: '50条',
          hint: '',
        },
        {
          text: '50条',
          hint: '',
        },
      ],
      [
        {
          text: '延时自动回复',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '免打扰自动回复',
          hint: '',
        },
        {
          text: '0',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '智能回复',
          hint: '',
        },
        {
          text: '0',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
    ],
  },
  {
    title: '群发功能',
    desc: '',
    id: 'table-club',
    data: [
      [
        {
          text: '通道',
          hint: '',
        },
        {
          text: '所有人公用一条通道',
          hint: '',
        },
        {
          text: '少量VIP公用一条通道',
          hint: '',
        },
        {
          text: '少量VIP公用极速通道',
          hint: '',
        },
        {
          text: '个人独享群发通道',
          hint: '',
        },
      ],
      [
        {
          text: '通道群发速度',
          hint: '',
        },
        {
          text: '300人/分钟',
          hint: '',
        },
        {
          text: '8000人/分钟',
          hint: '',
        },
        {
          text: '20000人/分钟',
          hint: '',
        },
        {
          text: '50000人/分钟',
          hint: '',
        },
      ],
      [
        {
          text: '客服群发配额',
          hint: '',
        },
        {
          text: '300条/天',
          hint: '',
        },
        {
          text: '5w条/天',
          hint: '',
        },
        {
          text: '10w条/天',
          hint: '',
        },
        {
          text: '20w条/天',
          hint: '',
        },
      ],
      [
        {
          text: '模板群发配额',
          hint: '',
        },
        {
          text: '累计10000条',
          hint: '',
        },
        {
          text: '10w条/天',
          hint: '',
        },
        {
          text: '50w条/天',
          hint: '',
        },
        {
          text: '100w条/天',
          hint: '',
        },
      ],
      [
        {
          text: '强制群发配额',
          hint: '',
        },
        {
          text: '5条/天',
          hint: '',
        },
        {
          text: '30条/天',
          hint: '',
        },
        {
          text: '70条/天',
          hint: '',
        },
        {
          text: '100条/天',
          hint: '',
        },
      ],
      [
        {
          text: '查看群发进度',
          hint: '',
        },
        {
          text: '0',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
      [
        {
          text: '查看群发详情',
          hint: '',
        },
        {
          text: '0',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
        {
          text: '1',
          hint: '',
        },
      ],
    ],
  },
  {
    title: '公众号额度',
    desc: '',
    id: 'table-post',
    data: [
      [
        {
          text: '接入公众号个数',
          hint: '',
        },
        {
          text: '1个',
          hint: '',
        },
        {
          text: '3个',
          hint: '',
        },
        {
          text: '5个',
          hint: '',
        },
        {
          text: '10个',
          hint: '',
        },
      ],
      [
        {
          text: '聊天记录保存',
          hint: '',
        },
        {
          text: '7天',
          hint: '',
        },
        {
          text: '永久',
          hint: '',
        },
        {
          text: '永久',
          hint: '',
        },
        {
          text: '永久',
          hint: '',
        },
      ],
      // [
      //   {
      //     text: '文章数量',
      //     hint: '',
      //   },
      //   {
      //     text: '40 个',
      //     hint: '',
      //   },
      //   {
      //     text: '200 个',
      //     hint: '',
      //   },
      //   {
      //     text: '不限',
      //     hint: '',
      //   },
      //   {
      //     text: '不限',
      //     hint: '',
      //   },
      // ],
    ],
  },
];
